import React from 'react'
import { ActionIcon } from '@mantine/core'

function Icon({ width, height, color = 'currentColor' }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16 16"
      class="design-iconfont"
      width={width}
      height={height}
    >
      <path
        fill={color}
        d="M2,7.45075421 L7.40854354,7.45075421 L7.40854354,12.8592978 L2,12.8592978 L2,7.45075421 Z M2,7.45075421 L4.28317911,3 L6.0273799,3 L3.74369375,7.45075421 L2,7.45075421 Z M8.59145646,7.45075421 L14,7.45075421 L14,12.8592978 L8.59145646,12.8592978 L8.59145646,7.45075421 Z M8.59145646,7.45075421 L10.8746356,3 L12.6188364,3 L10.3351502,7.45075421 L8.59145646,7.45075421 Z"
        fill-rule="nonzero"
      />
    </svg>
  )
}
const FontQuoteIcon = (props) => {
  const {
    fill = 'blue',
    variant = 'transparent',
    size = 'lg',
    radius = 'lg',
    width = 20,
    height = 20,
    loading = false,
    disabled = false,
  } = props
  return (
    <ActionIcon
      color={fill}
      variant={variant}
      size={size}
      radius={radius}
      loading={loading}
      disabled={disabled}
    >
      <Icon width={width} height={height} />
    </ActionIcon>
  )
}

export default FontQuoteIcon
